import { ValidUserProperties } from '../type';

// Currently, create user only required name and group names, this may change in the future when the API ready
export const isValidUserProperties = (data: { [key: string]: string }): data is ValidUserProperties => {
  return 'name' in data && !!data.name && 'groupnames' in data && !!data.groupnames;
};
